/** Build tenant login URL for platform super admins (same credentials, different subdomain). */
export function getTenantLoginUrl(subDomain: string | null | undefined): string {
    const slug = (subDomain || 'all').trim().toLowerCase();
    const { protocol, hostname, port } = window.location;
    const parts = hostname.split('.');

    if (parts.length >= 2) {
        parts[0] = slug;
        const host = parts.join('.');
        const portSuffix = port ? `:${port}` : '';
        return `${protocol}//${host}${portSuffix}/login`;
    }

    return `${protocol}//${slug}.cargozone.ai/login`;
}
